import { valueFormatterUSD } from "../components/AgGrid/grid-util";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import { myValueFormatter, myValueFormatter_quantity } from "./commonFunctions"

export const pnlSecurityColDefs = [
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Ticker',
      field: 'ticker',
      sortable: true,
      editable: false,
      minWidth: 75,
      maxWidth: 180,
      cellStyle: function () {
        return {
          display: 'flex',
          //borderRight: '0.5px solid #E1E1E1',
          alignItems: 'center'
        }
      },
      headerClass: function() {
        return 'ag-grid-mui-header';
      },
      cellRenderer: TickerHyperLinkComponent
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Cusip',
      field: 'cusip',
      sortable: true,
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1'
        }
      },
      minWidth: 80,
      maxWidth: 180,
      suppressSizeToFit: false,
      filterParams: {
        allowedCharPattern: '\\d\\-\\,',
        numberParser: (text: any) => {
          return parseFloat(text.replace(',', ''))
        }
      },
      headerClass: function() {
        return 'ag-grid-mui-header';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Borrow Qty',
      field: 'borr_qty',
      sortable: true,
      type: 'rightAligned',
      floatingFilter: false,
      editable: false,
      valueFormatter: myValueFormatter_quantity,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 105,
      maxWidth: 180,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Borrow Bal',
      field: 'borr_bal',
      sortable: true,
      type: 'rightAligned',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 105,
      maxWidth: 220,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      },
      valueFormatter: valueFormatterUSD
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Loan Qty',
      field: 'loan_qty',
      sortable: true,
      type: 'rightAligned',
      floatingFilter: false,
      editable: false,
      valueFormatter: myValueFormatter_quantity,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 90,
      maxWidth: 150,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Loan Bal',
      field: 'loan_bal',
      sortable: true,
      type: 'rightAligned',
      editable: false,
      valueFormatter: valueFormatterUSD,
      cellDataType:'text',
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          //borderRight: '0.5px solid #E1E1E1',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 110,
      maxWidth: 220,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Excess/Deficit',
      field: 'excess_deficit_bal',
      sortable: true,
      type: 'rightAligned',
      editable: false,
      valueFormatter: myValueFormatter,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.excess_deficit_bal >= 0 && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'flex-end',
            color:'rgb(38 112 38)',
           // background: TradeStatus.settled
          }
        } else if (params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'flex-end'
          }
        } else
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            color:'rgb(234 79 93)',
            //background: TradeStatus.error,
            justifyContent: 'flex-end'
          }
      },
      minWidth: 115,
      maxWidth: 220,
      headerClass: function() {
        
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Imbalance',
      field: 'excess_deficit_qty',
      sortable: true,
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.excess_deficit_qty === 'Deficit' && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            color:'rgb(234 79 93)',
           // backgroundColor: TradeStatus.error
          }
        } else if (params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
           // backgroundColor: TradeStatus.settled,
            color:'rgb(38 112 38)'
          }
        }
      },
      minWidth: 100,
      maxWidth: 200,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'PNL',
      field: 'pnl',
      sortable: true,
      type: 'rightAligned',
      floatingFilter: false,
      editable: false,
      valueFormatter: myValueFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.pnl >= 0 && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            color:'rgb(38 112 38)',
            justifyContent: 'flex-end',
            //background: TradeStatus.settled
          }
        } else if (params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'flex-end'
          }
        } else
          return {
            display: 'flex',
            alignItems: 'center',
            //borderRight: '0.5px solid #E1E1E1',
            //background: TradeStatus.error,
            color:'rgb(234 79 93)',
            justifyContent: 'flex-end'
          }
      },
      minWidth: 80,
      maxWidth: 200,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Borrow Contracts',
      field: 'borr_contracts',
      sortable: true,
      type: 'rightAligned',
      floatingFilter: false,
      editable: false,
      hide: true,
      valueFormatter: myValueFormatter_quantity,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 140,
      maxWidth: 180,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Loan Contracts',
      field: 'loan_contracts',
      sortable: true,
      type: 'rightAligned',
      floatingFilter: false,
      editable: false,
      hide: true,
      valueFormatter: myValueFormatter_quantity,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1',
          justifyContent: 'flex-end'
        }
      },
      minWidth: 140,
      maxWidth: 150,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    }
  ]